module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#strategy",
      toString: function () {
        return this.url;
      }
    }